import { Spinner } from "@pepdirect/v3/ui/Spinner";
import styled from "styled-components";

type Props = {
  isDisplayed: boolean;
};

export const StyledContainer = styled.div<Props>`
  ${({ isDisplayed }) =>
    !isDisplayed &&
    `
      display: none;
  `}
`;

export const StyledSpinner = styled(Spinner)`
  height: 200px;
  position: relative;
  > div {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`;
